module.exports = __webpack_public_path__ + "static/media/HCMM252.d1dc2906.jpg";